// Local publisher marks; asset provenance and license: public/model-publishers/.
export const PUBLISHER_LOGOS: Record<string, { src: string; monochrome: boolean }> = {
  "google": {"src": "/model-publishers/google-color.svg", "monochrome": false},
  "bytedance": {"src": "/model-publishers/bytedance-color.svg", "monochrome": false},
  "cognitivecomputations": {"src": "/model-publishers/dolphin.svg", "monochrome": true},
  "ibm-granite": {"src": "/model-publishers/ibm.svg", "monochrome": true},
  "microsoft": {"src": "/model-publishers/microsoft-color.svg", "monochrome": false},
  "minimax": {"src": "/model-publishers/minimax-color.svg", "monochrome": false},
  "nousresearch": {"src": "/model-publishers/nousresearch.svg", "monochrome": true},
  "nvidia": {"src": "/model-publishers/nvidia-color.svg", "monochrome": false},
  "openai": {"src": "/model-publishers/openai.svg", "monochrome": true},
  "poolside": {"src": "/model-publishers/poolside-color.svg", "monochrome": false},
  "rekaai": {"src": "/model-publishers/reka.svg", "monochrome": true},
  "stepfun": {"src": "/model-publishers/stepfun-color.svg", "monochrome": false},
  "tencent": {"src": "/model-publishers/tencent-color.svg", "monochrome": false},
  "trinity": {"src": "/model-publishers/arcee-color.svg", "monochrome": false},
  "xiaomi": {"src": "/model-publishers/xiaomimimo.svg", "monochrome": true},
  "z-ai": {"src": "/model-publishers/zai.svg", "monochrome": true},
  "zai-org": {"src": "/model-publishers/zai.svg", "monochrome": true},
  "anthracite-org": {"src": "/model-publishers/anthracite-org.webp", "monochrome": false},
  "inclusionai": {"src": "/model-publishers/inclusionai.webp", "monochrome": false},
  "meituan": {"src": "/model-publishers/meituan.webp", "monochrome": false},
  "nex-agi": {"src": "/model-publishers/nex-agi.webp", "monochrome": false},
  "prism-ml": {"src": "/model-publishers/prism-ml.webp", "monochrome": false},
  "sao10k": {"src": "/model-publishers/sao10k.webp", "monochrome": false},
  "thinkingmachines": {"src": "/model-publishers/thinkingmachines.webp", "monochrome": false},
  "deepseek": {"src": "/model-publishers/deepseek-color.svg", "monochrome": false},
  "deepseek-ai": {"src": "/model-publishers/deepseek-color.svg", "monochrome": false},
  "meta": {"src": "/model-publishers/meta-color.svg", "monochrome": false},
  "meta-llama": {"src": "/model-publishers/meta-color.svg", "monochrome": false},
  "mistralai": {"src": "/model-publishers/mistral-color.svg", "monochrome": false},
  "qwen": {"src": "/model-publishers/qwen-color.svg", "monochrome": false},
};
